/* File: assets/inb-downloads.js
   INBUS — Downloads Table Sort (client-side)
   - Default grouping: saule-rank ASC, then ID ASC
   - Clicking ID still sorts globally by ID (normal behavior)
*/
(function () {
  function norm(v) { return (v || "").toString().trim(); }
  function isNumeric(v) { return /^[0-9]+$/.test(norm(v)); }

  function compare(a, b, dir) {
    const av = norm(a);
    const bv = norm(b);

    let res;
    if (isNumeric(av) && isNumeric(bv)) {
      res = parseInt(av, 10) - parseInt(bv, 10);
    } else {
      res = av.localeCompare(bv, "de", { numeric: true, sensitivity: "base" });
    }
    return dir === "desc" ? -res : res;
  }

  document.addEventListener("DOMContentLoaded", function () {
    const table = document.querySelector("[data-inb-downloads-table]");
    if (!table) return;

    const tbody = table.querySelector("tbody");
    const headers = Array.from(table.querySelectorAll("th[data-inb-sort]"));
    if (!tbody || !headers.length) return;

    let activeKey = null;
    let dir = "asc";

    function renderSorted(rows, thEl, nextDir, key) {
      const frag = document.createDocumentFragment();
      rows.forEach((r) => frag.appendChild(r));
      tbody.appendChild(frag);

      headers.forEach((h) => h.classList.remove("inbus-sort--asc", "inbus-sort--desc"));
      if (thEl) thEl.classList.add(nextDir === "asc" ? "inbus-sort--asc" : "inbus-sort--desc");

      activeKey = key;
      dir = nextDir;
    }

    function applySort(key, nextDir, thEl) {
      const rows = Array.from(tbody.querySelectorAll("tr"));
      rows.sort((a, b) => compare(a.dataset[key], b.dataset[key], nextDir));
      renderSorted(rows, thEl, nextDir, key);
    }

    function applyDefaultGroupedSort(thEl) {
      const rows = Array.from(tbody.querySelectorAll("tr"));
      rows.sort((a, b) => {
        const ar = parseInt(a.dataset.sauleRank || "9", 10);
        const br = parseInt(b.dataset.sauleRank || "9", 10);
        if (ar !== br) return ar - br; // asc by rank
        return compare(a.dataset.id, b.dataset.id, "asc"); // then by id asc
      });
      renderSorted(rows, thEl, "asc", "id"); // arrow on ID
    }

    headers.forEach((th) => {
      th.setAttribute("role", "button");
      th.setAttribute("tabindex", "0");

      function handleClick() {
        const key = th.dataset.inbSort;
        if (!key) return;

        const nextDir = (activeKey === key && dir === "asc") ? "desc" : "asc";
        applySort(key, nextDir, th);
      }

      th.addEventListener("click", handleClick);
      th.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      });
    });

    // ✅ default: grouped by saule-rank then ID asc, arrow visible on ID
    const defaultTh = table.querySelector('th[data-inb-sort="id"]');
    if (defaultTh) {
      applyDefaultGroupedSort(defaultTh);
    }
  });
})();